import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import {
  User,
  Key,
  BarChart3,
  Webhook,
  BookOpen,
  ShieldCheck,
  LogOut,
  Sparkles
} from 'lucide-react';
import { useAuthStore } from '@/store/authStore';
import clsx from 'clsx';

const NAV = [
  { to: '/account', label: 'Account', icon: User },
  { to: '/keys', label: 'API Keys', icon: Key },
  { to: '/usage', label: 'Usage', icon: BarChart3 },
  { to: '/webhook', label: 'Webhook', icon: Webhook },
  { to: '/quickstart', label: 'Quickstart', icon: BookOpen },
  { to: '/trust', label: 'Trust', icon: ShieldCheck }
];

export function MainLayout() {
  const navigate = useNavigate();
  const customer = useAuthStore(s => s.customer);
  const clear = useAuthStore(s => s.clear);

  const logout = () => {
    clear();
    navigate('/login', { replace: true });
  };

  return (
    <div className="flex min-h-screen bg-nurev-bg">
      <aside className="flex w-60 flex-col border-r border-nurev-border bg-nurev-surface px-4 py-6">
        <div className="mb-8 flex items-center gap-3 px-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-gradient shadow-brand-glow">
            <Sparkles className="h-4 w-4 text-white" />
          </div>
          <div>
            <div className="text-sm font-bold tracking-wide text-nurev-text">
              NUREV
            </div>
            <div className="text-[10px] uppercase tracking-widest text-nurev-muted">
              Inference Console
            </div>
          </div>
        </div>

        <nav className="flex-1 space-y-1">
          {NAV.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                clsx(
                  'flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition',
                  isActive
                    ? 'bg-nurev-purple/15 text-nurev-purple-light'
                    : 'text-nurev-text-soft hover:bg-nurev-surface-lift hover:text-nurev-text'
                )
              }
            >
              <Icon className="h-4 w-4" />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="mt-6 border-t border-nurev-border pt-4">
          {customer && (
            <div className="mb-2 px-3 text-xs">
              <div className="font-medium text-nurev-text">{customer.name}</div>
              <div className="truncate text-nurev-muted">{customer.email}</div>
            </div>
          )}
          <button onClick={logout} className="btn-ghost w-full justify-start">
            <LogOut className="h-4 w-4" /> Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto">
        <div className="mx-auto max-w-5xl px-8 py-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
